import * as React from 'react'
import {Map, TileLayer, WMSTileLayer, LayersControl} from 'react-leaflet'
import {connect} from 'react-redux';
import {LEAFLET_EPSG25833_GEODATA, LEAFLET_EPSG25833_NIB} from '../../../map/NVDBCRS'
import MapUtils from '../../../map/map-utils';
import {dataforvalterMapConfig} from "../../../map/map-config";
import {
    DisplayFeature, UserSession,
    AssociationScope, CommonAssociationFeature
} from '../../contract-features-3/domain';
import WKTParser from 'terraformer-wkt-parser';
import FeatureLayer from './map/FeatureLayer';
import ZoomingFeatureGroup from '../../contract-features-3/components/map/ZoomingFeatureGroup';
import {
    setSelectFeatures,
    ToggleSelectedAssociationTarget,
    toggleSelectedAssociationTarget
} from '../../../actions/actions';
import {AssociatedFeature} from "../domain/AssociatedFeature";
import {MarkerType} from "./map/FeatureLayer";
import L, {LayersControlEvent} from "leaflet";
import AssociationsState, {FeatureTypeAttributes} from "../state/AssociationsState";

const {BaseLayer} = LayersControl;

interface StateProps {
    selectedFeature: DisplayFeature;
    selectedAssociation: AssociatedFeature;
    selectedAssociationTargetType: FeatureTypeAttributes;
    selectedTargetFeatures: CommonAssociationFeature[];
    selectedSourceFeature: DisplayFeature,
    targetFeatures: CommonAssociationFeature[],
    user: UserSession;
    tab: AssociationScope;
}

interface DispatchProps {
    onFeatureClick: ToggleSelectedAssociationTarget;
    onSelectFeatures: Function;
}

type FeatureMapProps = StateProps & DispatchProps;

interface FeatureMapState {
    lat: number,
    lng: number,
    zoom: number,
    crs: L.Proj.CRS
}
class FeatureMapComponent extends React.Component<FeatureMapProps, FeatureMapState> {
    private lengthMeasureControl: L.Control.PolylineMeasure;

    constructor(props: FeatureMapProps) {
        super(props);
        this.state = {
            lat: 63.43,
            lng: 10.40,
            zoom: 4,
            crs: LEAFLET_EPSG25833_GEODATA
        };
        this.lengthMeasureControl = L.control.polylineMeasure({
            measureControlTitleOn: "Mål avstand",
            measureControlTitleOff: "Mål avstand"
        });
    }


    render() {
        this.initLengthMeasurer();

        if (this.state.crs === LEAFLET_EPSG25833_GEODATA) {
            return (<Map
                className="map full-height"
                crs={this.state.crs}
                center={[this.state.lat, this.state.lng]}
                zoom={this.state.zoom}
                onbaselayerchange={e => this.setBaseLayerCrs(e)}
                doubleClickZoom={"center"}
                ref="map">
                <LayersControl position='bottomleft'>
                    <BaseLayer checked name='Geodata Online'>
                        <TileLayer
                            maxZoom={20}
                            minZoom={3}
                            maxNativeZoom={16}
                            attribution='NVDB'
                            url='https://nvdbcache.geodataonline.no/arcgis/rest/services/Trafikkportalen/GeocacheTrafikkJPG/MapServer/tile/{z}/{y}/{x}'
                        />
                    </BaseLayer>
                    <BaseLayer name='Norkart WebAtlas'>
                        <WMSTileLayer
                            maxZoom={20}
                            minZoom={0}
                            layers='WEBATLASNorge:Norge'
                            format='image/png'
                            url={'/rest/map/webatlas'}
                            attribution="Webatlas"
                        />
                    </BaseLayer>
                    <BaseLayer name='Norge i Bilder'>
                        <TileLayer
                            maxZoom={17}
                            minZoom={0}
                            layers='ortofoto'
                            format='image/jpeg'
                            url={'https://opencache3.statkart.no/gatekeeper/gk/gk.open_nib_utm33_wmts_v2?layer=Nibcache_UTM33_EUREF89_v2&style=default&tilematrixset=default028mm&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'}
                            attribution="GeoNorge"
                        />
                    </BaseLayer>
                </LayersControl >
                {this.getMarkers()}
            </Map>);
        } else if (this.state.crs === LEAFLET_EPSG25833_NIB) {
            return <>
                <p style={{height: 0, margin: 0}}>easter egg</p>
                <Map
                    className="map full-height"
                    crs={this.state.crs}
                    center={[this.state.lat, this.state.lng]}
                    zoom={this.state.zoom}
                    onbaselayerchange={e => this.setBaseLayerCrs(e)}
                    doubleClickZoom={"center"}
                    ref="map">
                    <LayersControl position='bottomleft'>
                        <BaseLayer name='Geodata Online'>
                            <TileLayer
                                maxZoom={20}
                                minZoom={3}
                                maxNativeZoom={16}
                                attribution='NVDB'
                                url='https://nvdbcache.geodataonline.no/arcgis/rest/services/Trafikkportalen/GeocacheTrafikkJPG/MapServer/tile/{z}/{y}/{x}'
                            />
                        </BaseLayer>
                        <BaseLayer name='Norkart WebAtlas'>
                            <WMSTileLayer
                                maxZoom={20}
                                minZoom={0}
                                layers='WEBATLASNorge:Norge'
                                format='image/png'
                                url={'/rest/map/webatlas'}
                                attribution="Webatlas"
                            />
                        </BaseLayer>
                        <BaseLayer checked name='Norge i Bilder'>
                            <TileLayer
                                maxZoom={17}
                                minZoom={0}
                                layers='ortofoto'
                                format='image/jpeg'
                                url={'https://opencache3.statkart.no/gatekeeper/gk/gk.open_nib_utm33_wmts_v2?layer=Nibcache_UTM33_EUREF89_v2&style=default&tilematrixset=default028mm&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'}
                                attribution="GeoNorge"
                            />
                        </BaseLayer>
                    </LayersControl >
                    {this.getMarkers()}
                </Map>);
            </>
        }
    }

    getMarkers() {
        let {selectedSourceFeature, targetFeatures} = this.props;

        if (!selectedSourceFeature) return null;
        const isDatafangstFeature = this.props.tab == "PROJECT_TO_PROJECT";

        let features = targetFeatures.map(f => this.featureToLayer(f, true, MarkerType.TARGET, this.isTargetFeatureSelected(f), this.isTargetFeatureAssociatied(f), isDatafangstFeature));
        // XXX Casting selectedSourceFeature here because of the generic CommonAssociationFeature vs DisplayFeature mixup
        let motherFeature = [this.featureToLayer(selectedSourceFeature as any, false, MarkerType.MOTHER, false, false, true)];

        return (
            <ZoomingFeatureGroup selectedFeatureTypeId={selectedSourceFeature.typeId} updateOnFeatureChange={true} enableAutoZoom={true}>
                {motherFeature}
                {features}
            </ZoomingFeatureGroup>
        );
    }

    setBaseLayerCrs = (e: LayersControlEvent) => {
        const newLayerName = e.name;
        if (newLayerName === "Norge i Bilder") {
            this.setState({
                crs: LEAFLET_EPSG25833_NIB
            })
        }
        if (newLayerName === "Geodata Online") {
            this.setState({
                crs: LEAFLET_EPSG25833_GEODATA
            })
        }
    }

    isTargetFeatureSelected(feature: CommonAssociationFeature) {
        return this.props.selectedTargetFeatures.filter(f => f.id === feature.id).length > 0;
    }

    isTargetFeatureAssociatied(feature: CommonAssociationFeature){
        let {selectedAssociation} = this.props;
        return selectedAssociation.childFeatures.some(childFeature => childFeature.id == feature.id);

    }


    featureToLayer(feature: CommonAssociationFeature, clickable: boolean, markerType: MarkerType, isSelected: boolean = false, isAssociated: boolean = false, isDatafangstFeature: boolean) {
        let wkt = feature.geometry.wkt;
        if (wkt) {
            let featurePosUtm33 = WKTParser.parse(wkt);
            let featurePosition = MapUtils.convertUtm33ToWgs84(featurePosUtm33);

            return (
                <FeatureLayer
                    isSelected={isSelected}
                    isAssociated={isAssociated}
                    featureClicked={() => this.featureClicked(feature, clickable)}
                    key={feature.id}
                    data={featurePosition}
                    feature={feature}
                    markerType={markerType}
                />
            );
        } else {
            return null;
        }
    }

    featureClicked(feature: CommonAssociationFeature, clickable: boolean) {
        if (clickable) {
            this.props.onFeatureClick(feature);
        }
    }

    initLengthMeasurer() {
        if (this.refs.map && !(this.lengthMeasureControl as any)._map) {
            (this.refs.map as Map).leafletElement.addControl(this.lengthMeasureControl);
        }
    }
}

const mapStateToProps = (state: AssociationsState): StateProps => {
    return {
        selectedFeature: state.selectedSourceFeature,
        selectedAssociation: state.selectedAssociation,
        selectedSourceFeature: state.selectedSourceFeature,
        selectedAssociationTargetType: state.selectedAssociationTargetType,
        selectedTargetFeatures: state.selectedTargetFeatures,
        targetFeatures: state.targetFeatures,
        user: state.user,
        tab: state.tab
    };
};
const mapDispatchToProps = ({
    onFeatureClick: toggleSelectedAssociationTarget,
    onSelectFeatures: setSelectFeatures
});
export default connect(mapStateToProps, mapDispatchToProps)(FeatureMapComponent);
